import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...props }, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }));
export default SvgChevron;
